<template>
  <v-container fluid>
    <template>
      <v-row>
        <v-col cols="6" class="pb-1 pt-0">
          <v-breadcrumbs :items="itemsBreadcrumbs" class="pl-0 pt-0 pb-1">
            <template v-slot:item="{ item }">
              <v-breadcrumbs-item :href="item.href" :disabled="item.disabled">
                {{ item.text.toUpperCase() }}
              </v-breadcrumbs-item>
            </template>
          </v-breadcrumbs>
        </v-col>
        <v-col cols="6" class="pb-1 pt-0 h-100">
          <office-login></office-login>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="10" class="pt-1">
          <span class="headline font-weight-medium">Convenio</span>
        </v-col>
        <v-col cols="2" class="pt-1">
          <v-btn
            dark
            color="#023145"
            width="140"
            class="float-right"
            @click="handleShowFilters"
          >
            Filtros
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" class="pt-1">
          <v-btn
            dark
            color="success"
            width="140"
            class="float-right"
            @click="handleDownloadReport"
          >
            Descargar XLS
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" class="pt-1">
          <v-card>
            <v-data-table
              :headers="headers"
              :items="convenios"
              item-key="id"
              :items-per-page="10"
              class="elevation-1 w-table"
              height="57vh"
              fixed-header
              :loading="loading"
              loading-text="Cargando datos ... "
              :options.sync="options"
              :server-items-length="paginated.total"
            >
              <template v-slot:item.sale_date="{ item }">
                <label
                  for=""
                  style="font-size: 11px;"
                  v-if="item.sales_canceled === true"
                  class="sale-cancel"
                >
                  {{ item.sale_date | moment("DD/MM/YYYY") }}
                </label>
                <label for="" style="font-size: 11px;" v-else>
                  {{ item.sale_date | moment("DD/MM/YYYY") }}
                </label>
              </template>

              <template v-slot:item.sale_serie="{ item }">
                <label
                  for=""
                  style="font-size: 11px;"
                  v-if="item.sales_canceled === true"
                  class="sale-cancel"
                >
                  {{ item.sale_serie }}-{{ item.sale_correlative }}
                </label>
                <label for="" style="font-size: 11px;" v-else>
                  {{ item.sale_serie }}-{{ item.sale_correlative }}
                </label>
              </template>

              <template v-slot:item.sale_total="{ item }">
                <label
                  for=""
                  style="font-size: 11px;"
                  v-if="item.sales_canceled === true"
                  class="sale-cancel"
                >
                  {{ item.sale_total | currency("S/") }}
                </label>
                <label for="" style="font-size: 11px;" v-else>
                  {{ item.sale_total | currency("S/") }}
                </label>
              </template>

              <template v-slot:item.services="{ item }">
                <label
                  for=""
                  style="font-size: 10px;"
                  v-if="item.sales_canceled === true"
                  class="sale-cancel"
                  >{{ item.services }}</label
                >
                <label for="" style="font-size: 10px;" v-else>{{
                  item.services
                }}</label>
              </template>

              <template v-slot:item.companies_name="{ item }">
                <label
                  for=""
                  style="font-size: 11px;"
                  v-if="item.sales_canceled === true"
                  class="sale-cancel"
                  >{{ item.companies_name }}</label
                >
                <label for="" style="font-size: 11px;" v-else>{{
                  item.companies_name
                }}</label>
              </template>

              <template v-slot:item.sale_order_code="{ item }">
                <label
                  for=""
                  style="font-size: 11px;"
                  v-if="item.sales_canceled === true"
                  class="sale-cancel"
                  >{{ item.sale_order_code }}</label
                >
                <label for="" style="font-size: 11px;" v-else>{{
                  item.sale_order_code
                }}</label>
              </template>

              <template v-slot:item.customer_name="{ item }">
                <label
                  for=""
                  style="font-size: 11px;"
                  v-if="item.sales_canceled === true"
                  class="sale-cancel"
                  >{{ item.customer_name }}</label
                >
                <label for="" style="font-size: 11px;" v-else>{{
                  item.customer_name
                }}</label>
              </template>

              <template v-slot:item.office_name="{ item }">
                <label
                  for=""
                  style="font-size: 11px;"
                  v-if="item.sales_canceled === true"
                  class="sale-cancel"
                  >{{ item.office_name }}</label
                >
                <label for="" style="font-size: 11px;" v-else>{{
                  item.office_name
                }}</label>
              </template>

              <template v-slot:item.debts_payment_amount="{ item }">
                <label
                  for=""
                  style="font-size: 11px;"
                  v-if="item.sales_canceled === true"
                  class="sale-cancel"
                  >{{
                    item.debts_payment_amount ? item.debts_payment_amount : "-"
                  }}</label
                >
                <label for="" style="font-size: 11px;" v-else>{{
                  item.debts_payment_amount ? item.debts_payment_amount : "-"
                }}</label>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-icon
                  size="16"
                  color="blue"
                  @click="handlePrintCreditNote(item)"
                >
                  fas fa-print
                </v-icon>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </template>

    <convenio-filters ref="convenioFilters"></convenio-filters>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import OfficeLogin from "../../../components/auth/OfficeLogin";
import ConvenioFilters from "../../../components/reports/ConvenioFilters";

import CreditNoteTicketTools from "../../../helpers/CreditNoteTicketTools";
import TicketTools from "../../../helpers/TicketTools";
import JQuery from "jquery";
let $ = JQuery;

export default {
  name: "CreditNotes",
  components: {
    ConvenioFilters,
    OfficeLogin,
  },
  data() {
    return {
      itemsBreadcrumbs: [
        {
          text: "Reportes",
          disabled: true,
          href: "",
        },
      ],
      headers: [
        { text: "FECHA", value: "sale_date", sortable: false },
        { text: "TIPO PAGO", value: "sale_payment_method", sortable: false },
        { text: "DOC. VENTA", value: "sale_serie", sortable: false },
        { text: "ORDEN.", value: "sale_order_code", sortable: false },
        { text: "EMPRESA", value: "companies_name", sortable: false },
        { text: "PACIENTE", value: "customer_name", sortable: false },
        {
          text: "SERVICIO",
          value: "services",
          sortable: false,
          width: 180,
        },
        {
          text: "SUCURSAL",
          value: "office_name",
          sortable: false,
        },

        {
          text: "INGRESO",
          value: "sale_total",
          sortable: false,
          width: 120,
        },
        {
          text: "SALDO",
          value: "debts_payment_amount",
          sortable: false,
          width: 120,
        },
        // {
        //   text: "",
        //   value: "actions",
        //   sortable: false,
        //   witdh: 50,
        // },
      ],
      loading: false,
      options: {},
      dataTable: { page: 1 },
      pageSelected: 1,
      perPage: 10,
    };
  },
  watch: {
    options: {
      handler() {
        this.loading = true;
        this.perPage = this.options.itemsPerPage;
        this.pageSelected = this.options.page;

        this.getConvenios({
          paginated: true,
          page: this.pageSelected,
          itemsPerPage: this.perPage,
          ...this.filters,
          // company_id: this.company_id,
        })
          .then((res) => (this.loading = false))
          .catch((err) => (this.loading = false));
      },
      deep: true,
    },
  },
  computed: {
    ...mapState("authentication", ["company_id"]),
    ...mapState("convenio", [
      "convenios",
      "filters",
      "file_name",
      "paginated",
      "filters",
    ]),
    ...mapState("report-sales", ["voucher"]),
  },
  methods: {
    ...mapActions("convenio", ["getConvenios", "downloadExcel"]),
    ...mapActions("report-sales", ["getSaleVoucher"]),
    handleShowFilters() {
      this.$refs.convenioFilters.show();
    },
    async handleDownloadReport() {
      let filters_data = Object.assign({}, this.filters);
      // filters_data.company_id = this.company_id;
      await this.downloadExcel(filters_data);
      if (this.file_name) {
        let url = process.env.VUE_APP_API_URL_BASE + "/" + this.file_name;
        window.open(url);
      }
    },
    async handlePrintCreditNote(credit_note) {
      await this.getSaleVoucher(credit_note.sale_id);
      if (this.voucher) {
        let content = await CreditNoteTicketTools.printTicketVentaNotaCredito(
          credit_note,
          this.voucher
        );
        // console.log("voucher", this.voucher);
        // let content = await TicketTools.printTicketVentaNotaCredito(
        //   credit_note,
        //   this.voucher
        // );
        this.printVoucher(content);
      }
    },
    printVoucher(content) {
      $("<iframe>", { name: "voucheriframe", class: "printFrame" })
        .appendTo("body")
        .contents()
        .find("body")
        .append(content);

      window.frames["voucheriframe"].focus();

      setTimeout(() => {
        window.frames["voucheriframe"].print();
      }, 400);

      setTimeout(() => {
        $(".printFrame").remove();
      }, 1000);
    },
  },
  created() {
    // this.getConvenios({
    //   company_id: this.company_id,
    // });
  },
};
</script>

<style scoped>
.sale-cancel {
  color: #f44336;
  font-weight: 600;
}
</style>
